import { createApi } from "../axiosSetup";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { NmUsuarioResponse } from "../types";

export const useMenuHubApi = () => {
    const { getAccessToken, setFeaturesToggles } = useAuth();
    const navigate = useNavigate();

    const authApi = async () => {
        const token = await getAccessToken();
        if (!token) {
            navigate("/");
            throw new Error("Token ausente — redirecionando.");
        }
        return createApi(token);
    };

    const getPainels = async () => {
        const api = await authApi();
        const { data } = await api.get("/users/painels");
        setFeaturesToggles(data?.outros || [])
        return data;
    };

    const getProfile = async (
        busca = "",
        itensPorPagina = 10,
        numeroPagina = 0
    ) => {
        const api = await authApi();

        const params = new URLSearchParams({
            itensPorPagina: itensPorPagina.toString(),
            numeroPagina: numeroPagina.toString(),
        });

        if (busca) {
            params.append("usuario", busca);
            params.append("email", busca);
            params.append("loginTasy", busca);
        }

        const { data } = await api.get(`/users?${params.toString()}`);
        return data;
    };

    const createProfile = async (body: any) => {
        const api = await authApi();
        const { data } = await api.post("/users", body);
        return data;
    };

    const getUserAccess = async (loginTasy: string) => {
        const api = await authApi();
        const { data } = await api.get(
            `/users/profile-access?LoginTasy=${encodeURIComponent(loginTasy)}`
        );
        return data;
    };

    const getAllProfiles = async () => {
        const api = await authApi();
        const { data } = await api.get("/profiles");
        return data.perfis;
    };

    const getUserProfiles = async (email: string, vinculados = true) => {
        const api = await authApi();

        const params = new URLSearchParams({
            email,
            vinculados: vinculados.toString(),
        });

        const { data } = await api.get(`/profiles/user?${params.toString()}`);
        return data;
    };

    const deleteUser = async (email: string) => {
        const api = await authApi();

        const { data } = await api.delete("/users", {
            data: { email },
        });

        return data;
    };

    const updateUser = async (body: { email: string; solucoesPermitidas: string, loginTasy?: string }) => {
        const api = await authApi();
        const { data } = await api.put("/users", body);
        return data;
    };

    const getNmUsuarioByEmail = async (dsEmail: string): Promise<NmUsuarioResponse> => {
        const api = await authApi();

        const params = new URLSearchParams({
            ds_email: dsEmail,
        });

        const { data } = await api.get<NmUsuarioResponse>(`/users/nm-usuario?${params.toString()}`);
        return data;
    };

    return {
        getPainels,
        getProfile,
        createProfile,
        getUserAccess, // n usa
        getAllProfiles,
        getUserProfiles,
        deleteUser,
        updateUser,
        getNmUsuarioByEmail,
    };
};
